module.exports = __webpack_public_path__ + "img/Group.3166774b.svg";